<script setup lang="ts">
import { gsap } from "gsap";

const { locales, locale } = useI18n();
const { alternateLanguages } = storeToRefs(usePageStore());
const { asLink } = usePrismic();
const selectorEl = ref<HTMLElement>();
const langs = computed(() =>
  locales.value.map((l) => {
    const url =
      asLink(alternateLanguages.value.find((v) => v.lang === l.language)) ||
      asLink({
        link_type: "Document",
        type: "home_page",
        id: "home_page",
        lang: l.language,
      });

    return {
      label: l.code.toUpperCase(),
      url: l.code === locale.value ? "" : (url as string),
    };
  }),
);

onNuxtReady(() => {
  gsap.to(selectorEl.value!, {
    opacity: 1,
    duration: 1,
    delay: 0.5,
    ease: "back.out(1.7)",
  });
});
</script>

<template>
  <div ref="selectorEl" class="transition-color relative flex items-center text-base opacity-0 -sm:text-sm">
    <div class="flex items-center">
      <div class="mr-2 h-[18px] w-[18px] -sm:h-[14px] -sm:w-[14px]">
        <i class="pi pi-globe"></i>
      </div>
      <NuxtLink v-if="langs[0].url" :to="langs[0].url" class="flex items-center hover:text-gray-500">
        {{ langs[0].label }}
      </NuxtLink>
      <span v-else class="underline">
        {{ langs[0].label }}
      </span>
      <span class="mx-[2px] text-xs">/</span>
      <NuxtLink v-if="langs[1].url" :to="langs[1].url" class="flex items-center hover:text-gray-500">
        {{ langs[1].label }}
      </NuxtLink>
      <span v-else class="underline">
        {{ langs[1].label }}
      </span>
    </div>
  </div>
</template>
